import api from "PFCore/api";
import { Id } from "PFCore/types";
import { KPIResult } from "PFCore/types/kpi";

export const RecalculateKPIs = (engagementId: Id): Promise<KPIResult[]> =>
  api<KPIResult[]>({
    url: `engagements/${engagementId}/kpi_results/recalculate`,
    method: "POST"
  });
